import clsx from 'clsx'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {FormComponent} from '../../parts/crud/Form'

export const Profile = () => {
  return (
    <>
      <CrudProvider api='profile'>
        <FormComponent redirect='/' customGet='/me' customPut='/me'
          text_modificato='Profilo aggiornato con successo'
          text_nuovo='Profilo aggiornato con successo'
        >
          {(formik, data, remoteErrors, isEdit) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='firstname' className='required fw-bold fs-6'>
                      Nome
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control form-control-solid', {
                        'is-invalid': formik.touched.firstname && formik.errors.firstname,
                        'is-valid': formik.touched.firstname && !formik.errors.firstname,
                      })}
                      id='firstname'
                      {...formik.getFieldProps('firstname')}
                    />
                    {formik.touched.firstname && formik.errors.firstname ? (
                      <em className='text-danger'>{formik.errors.firstname}</em>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='lastname' className='required fw-bold fs-6'>
                      Cognome
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control form-control-solid', {
                        'is-invalid': formik.touched.lastname && formik.errors.lastname,
                        'is-valid': formik.touched.lastname && !formik.errors.lastname,
                      })}
                      id='lastname'
                      name='lastname'
                      onChange={formik.handleChange}
                      value={formik.values.lastname}
                    />
                    {formik.touched.lastname && formik.errors.lastname ? (
                      <em className='text-danger'>{formik.errors.lastname}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='email' className='required fw-bold fs-6'>
                      Email
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control form-control-solid', {
                        'is-invalid':
                          (formik.touched.email && formik.errors.email) ||
                          remoteErrors.emailk !== undefined,
                        'is-valid':
                          formik.touched.email &&
                          !formik.errors.email &&
                          remoteErrors.email === undefined,
                      })}
                      id='email'
                      name='email'
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <em className='text-danger'>{formik.errors.email}</em>
                    ) : null}
                    {remoteErrors.email !== undefined ? (
                      <em className='text-danger'>{remoteErrors.email}</em>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className='row mb-6'>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='password' className=' fw-bold fs-6'>
                      Password
                    </label>
                    <input
                      type='password'
                      className={clsx('form-control form-control-solid', {
                        'is-invalid': formik.touched.password && formik.errors.password,
                        'is-valid': formik.touched.password && !formik.errors.password,
                      })}
                      id='password'
                      {...formik.getFieldProps('password')}
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <em className='text-danger'>{formik.errors.password}</em>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='password_confirm' className=' fw-bold fs-6'>
                      Conferma password
                    </label>
                    <input
                      type='password'
                      className={clsx('form-control form-control-solid', {
                        'is-invalid':
                          (formik.touched.password_confirm && formik.errors.password_confirm) ||
                          remoteErrors.password_confirm !== undefined,
                        'is-valid':
                          formik.touched.password_confirm &&
                          !formik.errors.password_confirm &&
                          remoteErrors.password_confirm === undefined,
                      })}
                      id='password_confirm'
                      name='password_confirm'
                      onChange={formik.handleChange}
                      value={formik.values.password_confirm}
                    />
                    {formik.touched.password_confirm && formik.errors.password_confirm ? (
                      <em className='text-danger'>{formik.errors.password_confirm}</em>
                    ) : null}
                    {remoteErrors.password_confirm !== undefined ? (
                      <em className='text-danger'>{remoteErrors.password_confirm}</em>
                    ) : null}
                  </div>
                </div>
              </div>
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}
